'use strict';

/**
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2015, COLIDO (http://www.colido.net)
 * @author     Cengiz Mardin <cm@humans.am>
 * @author     Augusto Campos Leiva <augusto@campos-leiva.de>
 */
var ColidoLayoutView = require('base/Colido.LayoutView');
var template = require('modules/settings/templates/layout/profile.hbs');
var UploadView = require('modules/settings/views/partials/profile/picture.js');
var LogoUploadView = require('modules/settings/views/partials/profile/logo.js');
var WincodeModalView = require('../modal/wincode-modal');

var ProfileLayout = ColidoLayoutView.extend({
    template: template,

    className: 'settings',
    ui: {
        updateProfile: '[data-action="update-profile"]',
        changeables: 'input,select',
        wincodeButton: '[data-action="enter-code"]',
        sellerProfile: '[name="sellerProfile"]',
        sellerProfileBlock: '.seller-profile-block',
    },

    childEvents: {
        'upload:state:selected': 'onUploadFileSelected',
        'upload:state:finished': 'onUploadFinished',
        'upload:state:error': 'onUploadError',
        'profile:changed': 'onProfileChanged',
    },

    events: {
        'click @ui.updateProfile': 'updateProfile',
        'change @ui.changeables': 'setSaveable',
        'keyup @ui.changeables': 'setSaveable',
        'click @ui.wincodeButton': 'onClickWincodeButton',
        'change @ui.sellerProfile': 'onSellerProfileChanged',
    },

    regions: {
        uploadRegion: '.profile-picture-region',
        logoRegion: '.profile-logo-region',
    },

    onShow: function() {
        this.uploadRegion.show(new UploadView({
            model: App.user,
        }));
        this.logoRegion.show(new LogoUploadView({
            model: App.user,
        }));
    },

    setSaveable: function() {
        this.ui.updateProfile.prop('disabled', false);
    },

    onProfileChanged: function() {
        this.setSaveable();
    },

    showLoading: function(element) {
        element.addClass('is-loading').prop('disabled', true);
    },

    hideLoading: function(element) {
        element.removeClass('is-loading').prop('disabled', false);
    },

    showSuccess: function(element) {
        Messenger().post({
            type: 'success',
            message: App.t('settings::profile:saveSuccess'),
        });

        this.hideLoading(element);
    },

    showFail: function(element) {
        Messenger().post({
            type: 'error',
            message: App.t('settings::profile:unknown-save-error'),
        });

        this.hideLoading(element);
    },

    updateProfile: function(event) {
        event.preventDefault();

        this.showLoading(this.ui.updateProfile);

        var attrs = {
            profileName: this.$('[name="name"]').val(),
            profileWebsite: this.$('[name="website"]').val(),
            profileBiography: this.$('[name="biography"]').val(),
            profilePictureId: this.$('.profile-picture-region [name="imageId"]').val(),
            profileLogoId: this.$('.profile-logo-region [name="imageId"]').val(),
            sellerProfile: this.$('[name="sellerProfile"]').filter(':checked').val(),
            sellerCompany: this.$('[name="company"]').val(),
            sellerContact: this.$('[name="contact"]').val(),
            sellerAddress: this.$('[name="address"]').val(),
            sellerPlz: this.$('[name="plz"]').val(),
            sellerCity: this.$('[name="city"]').val(),
            sellerCountry: this.$('[name="country"]').val(),
            sellerEmail: this.$('[name="email"]').val(),
            sellerWww: this.$('[name="www"]').val(),
            sellerPhone: this.$('[name="phone"]').val(),
            sellerRegistration: this.$('[name="registration"]').val(),
            sellerRegistrationOffice: this.$('[name="registrationOffice"]').val(),
            sellerUid: this.$('[name="uid"]').val(),
            sellerAgb: this.$('[name="agb"]').val(),
            sellerDse: this.$('[name="dse"]').val(),
            sellerNotes: this.$('[name="notes"]').val(),
        };

        App.user.save(attrs, {
            patch: true,
            wait: true,
            success: function(model) {
                if (!this.isDestroyed) {
                    this.showSuccess(this.ui.updateProfile);
                    this.ui.updateProfile.prop('disabled', true);
                }
            }.bind(this),
            error: function() {
                if (!this.isDestroyed) {
                    this.showFail(this.ui.updateProfile);
                }
            }.bind(this),
        });
    },

    /**
     * Is triggered, when the enter code button is clicked
     */
    onClickWincodeButton: function() {
        var wincodeModal = new WincodeModalView({model: this.model});
        App.addModal(wincodeModal, {
            additionalClassName: 'modal-center',
            additionalBgClassName: 'light-bg',
        });
    },

    onSellerProfileChanged: function() {
        this.ui.sellerProfileBlock.attr(
            'data-mode',
            this.ui.sellerProfile.filter(':checked').val()
        );
    },
});

module.exports = ProfileLayout;